import Header from 'components/ui/header'
import Loading from 'components/ui/loading'
import React, { Fragment, useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import { getActivity } from 'services/activity'
import Renderif from 'utils/renderif'

export default function ActivityView({ onProceed}) {
    const location = useLocation()
    const { id } = location.state || {}
    const navigate = useNavigate()
    const letters = ['a.', 'b.', 'c.', 'd.', 'e.', 'f.']
    const [state, setState] = useState({
        loading: true,
        questions:[],
        step:0,
        winner:true,
        answers:0,
        result:[]


    })
    useEffect(()=>{
        init()
        return () => {}
    },[])
    const init = async () => {
    
        setState({...state, loading: false})
        const response = await getActivity(id)
        
 
        if(Date.parse(response.data?.data?.expiration) < Date.parse(new Date()) || response.data?.data?.status === false){
          console.log("NO DISPONIBLE")
          navigate('/404')
          return;
        }

        navigate("/game/"+id)
        // state.questions = response.data?.data?.questions
        // state.loading = false
        // setState({...state})

    }
    
    const onAnswer = (option_id, id_question) => {


        let question = state.questions.find(question => question.id === id_question)
    

        if(option_id !== question.idAnswer){
            state.winner = false
            state.result.push(0)
        
        }else{
          state.answers = state.answers + 1;
          state.result.push(1)
        }

        if(state.step === state.questions.length - 1){
            console.log('FIN')
            console.log(state.winner)
            if(state.winner){
                onProceed()
                navigate('/winner', { state: { id: id } })
            }else{
                onProceed()
                // navigate('/winner', { state: { id: id } })
                navigate('/loser', { state: { id: id, answers:state.answers, lenght:state.questions.length, result:state.result } })
            }
        }else{
            setState({...state, step: state.step + 1})
        }
  
    }
    const checkImage = (image) => {
        if (!image) {
          return false
        }
        if (typeof image === 'string' && image.startsWith('https')) {
          return true
        }
        return false
      }
    
  return (
    <>
   
    <div className='container-fluid activity hide-scroll'>
          <Header />
          {
            state.questions?.map((question, index) => {
              return (
                <Renderif isTrue={state.step === index}>
                <div key={index} className='container mt-3 px-3'>

                  <div className='container'>
                    <h2>Pregunta {index + 1}</h2>
                    <h3 className='text-white'>{question.question}</h3>

                   <div className=''>
                    <Renderif isTrue={checkImage(question.image)}>
                          <img className='question-image' src={question.image} alt='imagen' />
                      </Renderif>

                      <Renderif isTrue={!checkImage(question.image)}>
                          <img className='question-image' src={'images/cine-yelmo.png'} alt="Yelmo" />
                      </Renderif>
                   </div>


                  </div>

                  <div className='col-12'>
                    {
                      question.options.map((option, index) => {
                        return (
                            <Fragment key={index}>
                                <Renderif isTrue={option.image !== null}>
                                        <div className='option' onClick={()=>{onAnswer(option.id, option.idQuestion)}}>
                                            <div className='option-item'>
                                                <div className='option-letter'>{letters[index]}</div>
                                                <img className='option-image' src={option.image} alt='imagen' />
                                            </div>
                                        </div>
                                </Renderif>
                                <Renderif isTrue={option.image === null}>
                                        <div className='option'  onClick={()=>{onAnswer(option.id, option.idQuestion)}}>
                          
                                                <div className='d-flex align-items-center'>
                                                    <div className='option-letter'>{letters[index]}</div>
                                                    <div className='option-answer'>{option.answer}</div>
                                                </div>
                                      
                                         
                                        </div>

                                </Renderif>
                            </Fragment>
                        )
                      })
                    }
                  </div>
                </div>
                </Renderif>
              )
            })
          }

          <div className='my-3 py-3'></div>
          <div className='my-3 py-3'></div>
          <div className='my-3 py-3'></div>

    </div>
    </>
  )
}
